import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';
import NumberFormat from 'react-number-format';
import useStageProgress from '../../../hooks/useStageProgress';

import ProjectCardAction from '../ProjectCardAction';
import ProjectCardStatus from '../ProjectCardStatus';
import ProjectCardMenu from '../ProjectCardMenu';
import ProjectCardCarbon from '../ProjectCardCarbon';
import './ProjectCard.scss';

import {
  ACTIVE_STATUS, FAILED_STATUS,
  CLOSED_STATUS, TERMINATED_STATUS, REFORESTATION_TYPE, AGROFORESTRY_TYPE,
} from '../../../constans/constans';
import { timerCountdown, nanoToMilli } from '../../../utils/helpers';

const ProjectCard = ({ data, refreshList }) => {
  const { _source, fields } = data;
  const { name, square, project_id: projectId, status, leakage, carbonApplication } = _source;
  const {
    currentStage: [currentStage],
    deadline: [deadline],
    isStagesFinished: [isStagesFinished],
    shortRegion: [shortRegion],
  } = fields;
  const [carbonAvailableTypes] = useState([REFORESTATION_TYPE, AGROFORESTRY_TYPE]);

  const typeOfCarbon = carbonAvailableTypes.includes(_source?.type);

  const history = useHistory();
  const translate = useIntl();
  const { isError, isLoading, stageProgress } = useStageProgress(_source, fields);
  const [stageTimeleft, setStageTimeleft] = useState(nanoToMilli(deadline));

  const getStage = () => {
    if (status === FAILED_STATUS
      || status === TERMINATED_STATUS
      || status === CLOSED_STATUS
      || currentStage === -1) {
      return 'None';
    }

    return currentStage + 1;
  };

  const getDeadline = () => (status === ACTIVE_STATUS ? timerCountdown(stageTimeleft) : '---');
  useEffect(() => {
    if (status !== ACTIVE_STATUS || isStagesFinished || currentStage < 0) return;

    const timer = setTimeout(() => {
      if (stageTimeleft <= 0) {
        refreshList();
        clearTimeout(timer);
      } else setStageTimeleft(stageTimeleft - 1000);
    }, 1000);

    return () => clearTimeout(timer);
  }, [stageTimeleft]);

  if (isError) {
    return (
      <div className="project-card">
        <div className="project-card__item">
          <div className="project-card__item-wrapper">
            <span>{translate.formatMessage({ id: 'projectCard.errorOccurred' })}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="project-card">
      <div className="project-card__item">
        <div className="project-card__item-wrapper">
          <div className="project-card__status">
            <ProjectCardStatus
              status={status}
              projectId={projectId}
              isStagesFinished={isStagesFinished}
            />
          </div>
          <div className="project-card__name overflow-scroll">
            <span className="project-card__name-value" onClick={() => history.push(`/project/${projectId}`)}>
              {name}
            </span>
          </div>
          <div className="project-card__action">
            <ProjectCardAction
              isLoading={isLoading}
              projectId={projectId}
              status={status}
              isStagesFinished={isStagesFinished}
              currentStage={currentStage}
              stageProgress={stageProgress}
              isCarbon={typeOfCarbon}
              dataOfProject={_source}

            />
          </div>
          <div className="project-card__carbon">
            <ProjectCardCarbon
              projectId={projectId}
              carbonApplication={carbonApplication}
              leakage={leakage}
            />
          </div>
          <div className="project-card__stage overflow-scroll">{getStage()}</div>
          <div className="project-card__location overflow-scroll">
            <i className="icon-marker" />
            <span>{shortRegion}</span>
          </div>
          <div className="project-card__square overflow-scroll">
            <span><NumberFormat value={square} displayType="text" thousandSeparator decimalScale={3} /></span>
          </div>
          <div className="project-card__timeleft overflow-scroll">
            <i className="icon-clock" />
            {getDeadline()}
          </div>
          <div className="project-card__popup">
            <ProjectCardMenu
              isLoading={isLoading}
              projectId={projectId}
              status={status}
              isStagesFinished={isStagesFinished}
              stageProgress={stageProgress}
              carbonApplication={carbonApplication}
              isCarbon={typeOfCarbon}
              dataOfProject={_source}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
